'use client';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   InputGroup,
   Spinner,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorMode,
   useColorModeValue,
   useDisclosure,
   useOutsideClick,
} from '@chakra-ui/react';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Thead, Th, Grid } from '@chakra-ui/react';
import Select from 'react-select';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import DynamicFilterall from '../components/DynamicFilterall';
import SalesPurchaseFilter from '../components/SalesPurchaseFilter';
// import { getCompanies } from '../../../../redux/actions/company';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { clearCacheReport, getInventoryDetailReport } from '../../../../redux/actions/reports';
// import { columnsReportsSalesDetail } from '../../customDataTable/variables/columnsData';
import { createColumnHelper } from '@tanstack/react-table';
import { useGlobal } from '../../../../contexts';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { getShareCompanyOptions } from 'utils/util';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getItem } from '../../../../redux/actions/item';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { useUser } from 'contexts';
import { LuRefreshCcw } from 'react-icons/lu';
import { IoFilterOutline } from 'react-icons/io5';
import { motion } from 'framer-motion';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { MdCompress, MdExpand } from 'react-icons/md';
import * as XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getSinglePurchaseWithPrevAndNext } from '../../../../redux/actions/purchaseInvoice';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../redux/actions/account';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord } from 'utils/util';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const SEARCH_DEBOUNCE_DELAY = 300; // Optimal debounce delay for search
const MIN_LOADING_TIME = 300;

const InventoryDetail = () => {
   const { companyList } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const columnHelper = createColumnHelper();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const storedCompanyId = localStorage.getItem('companyId');
   const [fromDate, setFromDate] = useState(null);
   const [allExpanded, setAllExpanded] = useState(false);
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const [companyFilter, setCompanyFilter] = useState([]);
   const dbName = localStorage.getItem('dbName');
   const [expandedItems, setExpandedItems] = useState({});
   const dispatch = useDispatch();
   const fromDateInputRef = useRef(null);
   const { user } = useUser();
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [itemId, setItemId] = useState([]);
   const [searchQuery, setSearchQuery] = useState('');
   const [isSearchLoading, setIsSearchLoading] = useState(false);
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const searchTimeoutRef = useRef(null);
   const abortControllerRef = useRef(null);
   const [isLoading, setIsLoading] = useState(false);
   const salesReport = useSelector((state) => state.reports?.inventoryDetail || []);
   const itemList = useSelector((state) => state.item.list || []);
   const [entityType, setEntityType] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityType === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else {
         return {};
      }
   });
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;
   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityType === 'salereturn'
               ? viewDatasr?.data[0]
               : entityType === 'saleinvoice'
                  ? viewDatasi
                  : entityType === 'purchaseinvoice'
                     ? viewDatapi
                     : null;

      const pagination =
         entityType === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityType === 'salereturn'
               ? viewDatasr?.pagination
               : entityType === 'saleinvoice'
                  ? viewDatasi?.pagination
                  : entityType === 'purchaseinvoice'
                     ? viewDatapi?.pagination
                     : null;

      return { viewDetail: data, paginate: pagination };
   }, [
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi,
      viewDatapi,
   ]);
   const handleCompanyChange = (selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   };
   const handleItemChange = (selectedOptions) => {
      setItemId(selectedOptions ? selectedOptions.map((opt) => opt.value) : []);
   };
   const toggleExpand = (id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   };
   const itemOptions = useMemo(() => {
      return itemList.map((item) => ({
         value: item.id,
         label: item.name,
      }));
   }, [itemList]);

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = companyOptions.map((company) => ({
      value: company.value,
      label: company.label,
      id: company.value,
      name: company.label,
   }));

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   useEffect(() => {
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         // Find the company in the company list that matches the stored ID
         const matchingCompany = companyList?.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   useEffect(() => {
      if (!fromDate) {
         const today = new Date();
         today.setFullYear(today.getFullYear() - 1);
         const formattedDate = today.toISOString().split('T')[0];
         setFromDate(formattedDate); // Set the default value if null
      }
   }, [fromDate]);
   useEffect(() => {
      const fetchData = async () => {
         setIsLoading(true); // Set loading state to true at start

         try {
            dispatch(clearCacheReport());

            // Create and validate company IDs
            const companyIds =
               companyFilter.length > 0
                  ? companyFilter
                  : localStorage.getItem('companyId')
                     ? [parseInt(localStorage.getItem('companyId'), 10)]
                     : [];

            // Validate company IDs - must be valid numbers greater than 0
            const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

            // If no valid company IDs, skip the API calls
            if (validCompanyIds.length === 0) {
               console.log('No valid company IDs, skipping API calls');
               return;
            }

            const companyIdsString = validCompanyIds.join(',');

            // Fetch item data if we have valid company IDs
            await dispatch(
               getItem({
                  companyId: user?.loginhistory?.companyId ?? validCompanyIds[0], // Use first valid company ID as fallback
               }),
            );

            // Validate item IDs
            const validItemIds = itemId.filter((id) => !isNaN(Number(id)) && Number(id) > 0);
            const itemIdsString = validItemIds.join(',');

            // Only proceed if we have valid dates and company IDs
            if (dateRange && fromDate && toDate) {
               const params = {
                  companyIds: companyIdsString,
                  fromDate: dateRange.fromDate,
                  toDate: dateRange.toDate,
                  orderBy: 'asc',
                  search: debouncedSearchQuery,
                  ...(validItemIds.length > 0 && { itemIds: itemIdsString }), // Conditionally add itemIds
               };

               await dispatch(getInventoryDetailReport(params));
            }
         } catch (error) {
            console.error('Error fetching inventory report:', error);
            // Optionally handle error (e.g., show toast notification)
         } finally {
            setIsLoading(false); // Ensure loading is set to false when done
         }
      };

      fetchData();
   }, [
      dispatch,
      companyFilter,
      itemId,
      fromDate,
      toDate,
      storedCompanyId,
      user?.loginhistory?.companyId,
      debouncedSearchQuery,
      dateRange,
   ]);
   const handleRefresh = () => {
      setIsLoading(true);
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [];
      const validCompanyIds = companyIds.filter((id) => !isNaN(id) && id !== null);
      const companyIdsString = validCompanyIds.length > 0 ? validCompanyIds.toString() : '';

      const validItemIds = itemId.filter((id) => !isNaN(id) && id !== null);
      const itemIdsString = validItemIds.length > 0 ? validItemIds.toString() : '';
      if (fromDate && toDate && companyIdsString !== '') {
         // Create params object
         const params = {
            companyIds: companyIdsString,
            fromDate,
            toDate,
            orderBy: 'asc',
            search: debouncedSearchQuery,
         };

         // Only add itemIds if we have valid values
         if (itemIdsString !== '') {
            params.itemIds = itemIdsString;
         }

         // Dispatch with conditional params
         dispatch(getInventoryDetailReport(params));
      }
   };

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));

      setDateRange({ fromDate: from, toDate: to });
   };
   const handleSearchChange = useCallback((e) => {
      const value = e.target.value;
      setSearchQuery(value); // Update UI immediately

      // Clear previous timeout and abort ongoing request
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }
      if (abortControllerRef.current) {
         abortControllerRef.current.abort();
      }

      // Only search if query is not empty
      if (value.trim()) {
         setIsSearchLoading(true);
         searchTimeoutRef.current = setTimeout(() => {
            performSearch(value.trim());
         }, SEARCH_DEBOUNCE_DELAY);
      } else {
         // If search is cleared, refresh with original data
         handleRefresh();
      }
   }, []);
   useEffect(() => {
      const handler = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
      }, 500);

      return () => {
         clearTimeout(handler);
      };
   }, [searchQuery]);

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const performSearch = useCallback(
      async (query) => {
         if (!query) return;

         const startTime = Date.now();

         try {
            abortControllerRef.current = new AbortController();

            const companyIds =
               companyFilter.length > 0
                  ? companyFilter
                  : localStorage.getItem('companyId')
                     ? [parseInt(localStorage.getItem('companyId'))]
                     : [];

            const validCompanyIds = companyIds.filter((id) => !isNaN(id) && id !== null);
            const companyIdsString = validCompanyIds.join(',');

            await dispatch(
               getInventoryDetailReport({
                  companyIds: companyIdsString,
                  fromDate: dateRange?.fromDate || fromDate,
                  toDate: dateRange?.toDate || toDate,
                  orderBy: 'asc',
                  search: query,
                  ...(itemId.length > 0 && { itemIds: itemId.join(',') }),
               }),
               { signal: abortControllerRef.current.signal },
            );
         } catch (error) {
            if (error.name !== 'AbortError') {
               console.error('Search error:', error);
            }
         } finally {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, MIN_LOADING_TIME - elapsedTime);

            if (remainingTime > 0) {
               await new Promise((resolve) => setTimeout(resolve, remainingTime));
            }

            setIsSearchLoading(false);
            abortControllerRef.current = null;
         }
      },
      [companyFilter, dateRange, fromDate, toDate, itemId],
   );

   // Add this useEffect
   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
         }
      };
   }, []);

   useEffect(() => {
      if (salesReport && salesReport.length > 0) {
         // Create a new object with all company IDs set to expanded
         const initialExpandedState = {};

         salesReport.forEach((companyData) => {
            // Set company as expanded
            initialExpandedState[`company-${companyData.companyId}`] = true;

            // If you also want account-level items expanded by default
            if (companyData.data && Array.isArray(companyData.data)) {
               companyData.data.forEach((itemData) => {
                  initialExpandedState[`item-${itemData.itemId}`] = true;
               });
            }
         });

         // Set the expanded items state
         setExpandedItems(initialExpandedState);
      }
   }, [salesReport]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const expandAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         companyData.data?.forEach((itemData) => {
            const itemKey = `item-${itemData.itemId}`; // Changed to match toggleExpand keys
            newExpanded[itemKey] = true;
         });
      });
      setExpandedItems(newExpanded);
      setAllExpanded(true);
   }, [salesReport]);

   const collapseAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true; // Keep companies expanded

         companyData.data?.forEach((itemData) => {
            const itemKey = `item-${itemData.itemId}`; // Changed to match toggleExpand keys
            newExpanded[itemKey] = false; // Collapse all items
         });
      });
      setExpandedItems(newExpanded);
      setAllExpanded(false);
   }, [salesReport]);

   const columnsReportsSalesDetail = [
      {
         id: 'date',
         header: 'Date',
         accessorKey: 'date',
      },
      {
         id: 'docNumber',
         header: 'Doc#',
         accessorKey: 'docNumber',
      },
      {
         id: 'party',
         header: 'Account',
         accessorKey: 'party',
      },
      {
         id: 'daybook',
         header: 'Daybook',
         accessorKey: 'daybook',
      },
      {
         id: 'recqty1',
         header: 'Receipts Qty 1',
         accessorKey: 'qty1',
      },
      {
         id: 'issqty1',
         header: 'Issues Qty 1',
         accessorKey: 'qty1',
      },
      {
         id: 'bal1',
         header: 'Balance Qty 1',
         accessorKey: 'bal1',
      },
      {
         id: 'itemRate',
         header: 'Rate',
         accessorKey: 'itemRate',
      },
   ];

   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsReportsSalesDetail.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   const calculateItemTotals = (itemData) => {
      // Check if item data exists and has transactions
      if (!itemData || !itemData.data || !Array.isArray(itemData.data)) {
         return {
            balanceTotal: 0,
            receiptQtyTotal: 0,
            issueQtyTotal: 0,
            rateTotal: 0,
         };
      }

      // Initialize totals
      let balanceTotal = itemData.totalBal1 || 0; // Use existing totalBal1 if available
      let receiptQtyTotal = 0;
      let issueQtyTotal = 0;
      let rateTotal = 0;

      // Process all transactions
      itemData.data.forEach((transaction) => {
         // Add receipt quantities (positive qty1)
         if (transaction.qty1 > 0) {
            receiptQtyTotal += transaction.qty1;
         }
         // Add issue quantities (negative qty1, but store as positive)
         else if (transaction.qty1 < 0) {
            issueQtyTotal += Math.abs(transaction.qty1);
         }

         // Add item rates if they exist
         if (transaction.itemRate !== undefined && !isNaN(parseFloat(transaction.itemRate))) {
            rateTotal += parseFloat(transaction.itemRate);
         }
      });

      return {
         balanceTotal,
         receiptQtyTotal,
         issueQtyTotal,
         rateTotal,
      };
   };

   // Function to calculate company totals
   const calculateCompanyTotals = (companyData) => {
      // Check if company data exists and has items
      if (!companyData || !companyData.data || !Array.isArray(companyData.data)) {
         return {
            balanceTotal: 0,
            receiptQtyTotal: 0,
            issueQtyTotal: 0,
            rateTotal: 0,
         };
      }

      // Initialize totals
      let balanceTotal = 0;
      let receiptQtyTotal = 0;
      let issueQtyTotal = 0;
      let rateTotal = 0;

      // Sum up values from all items and their transactions
      companyData.data.forEach((item) => {
         // Add item balance to total
         balanceTotal += item.totalBal1 || 0;

         // Process transactions if they exist
         if (item.data && Array.isArray(item.data)) {
            item.data.forEach((transaction) => {
               // Add receipt quantities (positive qty1)
               if (transaction.qty1 > 0) {
                  receiptQtyTotal += transaction.qty1;
               }
               // Add issue quantities (negative qty1, but store as positive)
               else if (transaction.qty1 < 0) {
                  issueQtyTotal += Math.abs(transaction.qty1);
               }

               // Add item rates if they exist
               if (transaction.itemRate !== undefined && !isNaN(parseFloat(transaction.itemRate))) {
                  rateTotal += parseFloat(transaction.itemRate);
               }
            });
         }
      });

      return {
         balanceTotal,
         receiptQtyTotal,
         issueQtyTotal,
         rateTotal,
      };
   };

   const generateLast40Months = () => {
      const months = [];
      const currentDate = new Date();
      for (let i = 0; i < 40; i++) {
         const year = currentDate.getFullYear();
         const month = currentDate.toLocaleString('en-US', { month: 'short' }); // Example: "Feb"

         months.push(`${month} ${year}`);

         // Move to the previous month
         currentDate.setMonth(currentDate.getMonth() - 1);
      }
      return months;
   };

   const secondOptions = generateLast40Months();

   const columns = columnsReportsSalesDetail
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color="gray.400">
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   // Add this utility function at the top of your file
   const formatDateToDDMMYYYY = (dateString) => {
      if (!dateString) return '-';

      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-'; // Handle invalid dates

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
   };
   const exportToExcel = () => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new workbook
         const wb = XLSX.utils.book_new();

         // Define styles to match UI
         const styles = {
            reportTitle: {
               font: { bold: true, sz: 16 },
               alignment: { horizontal: 'center' },
            },
            dateRange: {
               font: { italic: true, sz: 12 },
               alignment: { horizontal: 'center' },
            },
            companyHeader: {
               fill: { fgColor: { rgb: 'F1E7E7' } }, // Light pink
               font: { bold: true, sz: 14, color: { rgb: '000000' } },
               alignment: { horizontal: 'left' },
            },
            itemHeader: {
               fill: { fgColor: { rgb: 'F8FAFC' } }, // Very light gray
               font: { bold: true, sz: 12, color: { rgb: '000000' } },
               alignment: { horizontal: 'left' },
            },
            tableHeader: {
               fill: { fgColor: { rgb: 'F5F5F5' } }, // Light gray
               font: { bold: true, sz: 11, color: { rgb: '000000' } },
               alignment: { horizontal: 'center' },
               border: {
                  top: { style: 'thin', color: { rgb: '000000' } },
                  bottom: { style: 'thin', color: { rgb: '000000' } },
                  left: { style: 'thin', color: { rgb: '000000' } },
                  right: { style: 'thin', color: { rgb: '000000' } },
               },
            },
            oddRow: {
               fill: { fgColor: { rgb: 'FFFFFF' } }, // White
               font: { sz: 11 },
               border: {
                  top: { style: 'thin', color: { rgb: 'DDDDDD' } },
                  bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
               },
            },
            evenRow: {
               fill: { fgColor: { rgb: 'EFF6FF' } }, // Very light blue
               font: { sz: 11 },
               border: {
                  top: { style: 'thin', color: { rgb: 'DDDDDD' } },
                  bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
               },
            },
            totalRow: {
               fill: { fgColor: { rgb: 'F5EEE6' } }, // Light tan
               font: { bold: true, sz: 12, color: { rgb: '000000' } },
               alignment: { horizontal: 'right' },
            },
            grandTotalRow: {
               fill: { fgColor: { rgb: 'F1E7E7' } }, // Light pink
               font: { bold: true, sz: 12, color: { rgb: 'FF0000' } }, // Red text
               alignment: { horizontal: 'right' },
            },
            numberFormat: {
               numFmt: '#,##0.00',
            },
            currencyFormat: {
               numFmt: '"₹"#,##0.00',
            },
         };

         // Process all data for Excel
         const allData = [];

         // Add report title
         allData.push([{ v: 'Inventory Detail Report', s: styles.reportTitle }]);

         // Add date range
         allData.push([
            {
               v: `From ${formatDateToDDMMYYYY(dateRange?.fromDate || fromDate)} to ${formatDateToDDMMYYYY(
                  dateRange?.toDate || toDate,
               )}`,
               s: styles.dateRange,
            },
         ]);

         allData.push([]); // Empty row

         salesReport.forEach((companyData) => {
            const companyTotals = calculateCompanyTotals(companyData);

            // Add company header with grand total in the same row
            allData.push([
               { v: companyData.companyName, s: styles.companyHeader },
               { v: '', s: styles.companyHeader },
               { v: 'Grand Total', s: { ...styles.companyHeader, alignment: { horizontal: 'center' } } },
               { v: '', s: styles.companyHeader },
               {
                  v: companyTotals.receiptQtyTotal,
                  t: 'n',
                  s: { ...styles.companyHeader, ...styles.numberFormat, alignment: { horizontal: 'right' } },
               },
               {
                  v: companyTotals.issueQtyTotal,
                  t: 'n',
                  s: { ...styles.companyHeader, ...styles.numberFormat, alignment: { horizontal: 'right' } },
               },
               {
                  v: companyTotals.balanceTotal,
                  t: 'n',
                  s: { ...styles.companyHeader, ...styles.numberFormat, alignment: { horizontal: 'right' } },
               },
               {
                  v: companyTotals.rateTotal,
                  t: 'n',
                  s: { ...styles.companyHeader, ...styles.currencyFormat, alignment: { horizontal: 'right' } },
               },
            ]);
            allData.push([]); // Empty row

            companyData.data.forEach((itemData) => {
               const itemTotals = calculateItemTotals(itemData);

               // Add item header with item total in the same row
               allData.push([
                  { v: `Item: ${itemData.itemName}`, s: styles.itemHeader },
                  { v: '', s: styles.itemHeader },
                  { v: 'Item Total', s: { ...styles.itemHeader, alignment: { horizontal: 'center' } } },
                  { v: '', s: styles.itemHeader },
                  {
                     v: itemTotals.receiptQtyTotal,
                     t: 'n',
                     s: { ...styles.itemHeader, ...styles.numberFormat, alignment: { horizontal: 'right' } },
                  },
                  {
                     v: itemTotals.issueQtyTotal,
                     t: 'n',
                     s: { ...styles.itemHeader, ...styles.numberFormat, alignment: { horizontal: 'right' } },
                  },
                  {
                     v: itemData.totalBal1,
                     t: 'n',
                     s: { ...styles.itemHeader, ...styles.numberFormat, alignment: { horizontal: 'right' } },
                  },
                  {
                     v: itemTotals.rateTotal,
                     t: 'n',
                     s: { ...styles.itemHeader, ...styles.currencyFormat, alignment: { horizontal: 'right' } },
                  },
               ]);

               // Add table headers
               const headers = columnsReportsSalesDetail.map((col) => ({
                  v: col.header,
                  s: styles.tableHeader,
               }));
               allData.push(headers);

               // Add opening balance if exists
               if (companyData[0]?.totalOpeningBal1 > 0) {
                  allData.push([
                     { v: '', s: styles.evenRow },
                     { v: '', s: styles.evenRow },
                     { v: 'Opening Balance', s: { ...styles.evenRow, font: { bold: true, sz: 12 } } },
                     { v: '', s: styles.evenRow },
                     { v: '', s: styles.evenRow },
                     { v: '', s: styles.evenRow },
                     { v: companyData[0].totalOpeningBal1, t: 'n', s: { ...styles.evenRow, ...styles.numberFormat } },
                     { v: '', s: styles.evenRow },
                  ]);
               }

               // Add transaction data with alternating row colors
               itemData.data.forEach((transaction, index) => {
                  const rowStyle = index % 2 === 0 ? styles.evenRow : styles.oddRow;

                  allData.push([
                     {
                        v: transaction.transactionAt ? formatDateToDDMMYYYY(transaction.transactionAt) : '',
                        s: rowStyle,
                     },
                     { v: transaction.docno || '', s: rowStyle },
                     { v: transaction.accountName || '', s: rowStyle },
                     { v: transaction.daybookName || '', s: rowStyle },
                     {
                        v: transaction.qty1 > 0 ? transaction.qty1 : '',
                        t: 'n',
                        s: { ...rowStyle, ...styles.numberFormat },
                     },
                     {
                        v: transaction.qty1 < 0 ? Math.abs(transaction.qty1) : '',
                        t: 'n',
                        s: { ...rowStyle, ...styles.numberFormat },
                     },
                     {
                        v: transaction.bal1 !== undefined ? transaction.bal1 : '',
                        t: 'n',
                        s: { ...rowStyle, ...styles.numberFormat },
                     },
                     {
                        v: transaction.itemRate !== undefined ? transaction.itemRate : '',
                        t: 'n',
                        s: { ...rowStyle, ...styles.currencyFormat },
                     },
                  ]);
               });

               allData.push([]); // Empty row after each item
            });

            allData.push([]); // Empty row after each company
         });

         // Create worksheet
         const ws = XLSX.utils.aoa_to_sheet(allData);

         // Set column widths
         ws['!cols'] = [
            { wch: 12 }, // Date
            { wch: 15 }, // Doc#
            { wch: 25 }, // Account
            { wch: 20 }, // Daybook
            { wch: 15 }, // Receipts Qty
            { wch: 15 }, // Issues Qty
            { wch: 15 }, // Balance Qty
            { wch: 15 }, // Rate
         ];

         // Add merge ranges for headers
         ws['!merges'] = [
            // Merge report title (A1:H1)
            { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } },
            // Merge date range (A2:H2)
            { s: { r: 1, c: 0 }, e: { r: 1, c: 7 } },
         ];

         // Add merge ranges for company and item headers
         let mergeRow = 3; // Start after title and empty rows
         salesReport.forEach((companyData) => {
            // Merge company name (A:B) in company header row
            ws['!merges'].push({ s: { r: mergeRow, c: 0 }, e: { r: mergeRow, c: 1 } });
            mergeRow += 2; // Skip empty row

            companyData.data.forEach((itemData) => {
               // Merge item name (A:B) in item header row
               ws['!merges'].push({ s: { r: mergeRow, c: 0 }, e: { r: mergeRow, c: 1 } });
               mergeRow += 1 + (itemData.data?.length || 0) + 1; // Headers + data + empty row

               // Add opening balance row if exists
               if (companyData[0]?.totalOpeningBal1 > 0) {
                  mergeRow += 1;
               }
            });

            mergeRow += 1; // Skip empty row after company
         });

         // Add worksheet to workbook
         XLSX.utils.book_append_sheet(wb, ws, 'Inventory Detail');

         // Generate safe file name
         const now = new Date();
         const safeFileName = `Inventory_Detail_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.xlsx`;

         // Write file
         XLSX.writeFile(wb, safeFileName);
      } catch (error) {
         console.error('Error exporting to Excel:', error);
         alert('Failed to export Excel file. Please try again.');
      }
   };

   const exportToPDF = () => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new PDF document
         const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
         });

         // Add report title
         doc.setFontSize(16);
         doc.setFont('helvetica', 'bold');
         doc.text('Inventory Detail Report', 140, 10, { align: 'center' });

         // Add date range
         doc.setFontSize(12);
         doc.setFont('helvetica', 'normal');
         doc.text(
            `From ${formatDateToDDMMYYYY(dateRange?.fromDate || fromDate)} to ${formatDateToDDMMYYYY(
               dateRange?.toDate || toDate,
            )}`,
            140,
            18,
            { align: 'center' },
         );

         // Define styles with darker headers
         const styles = {
            header: {
               fillColor: [241, 231, 231], // Light pink
               textColor: 0, // Black
               fontStyle: 'bold',
               fontSize: 10,
            },
            subHeader: {
               fillColor: [248, 250, 252], // Very light gray
               textColor: 0,
               fontStyle: 'bold',
               fontSize: 9,
            },
            tableHeader: {
               fillColor: [245, 245, 245], // Light gray
               textColor: 0,
               fontStyle: 'bold',
               fontSize: 8,
            },
            oddRow: {
               textColor: 0,
               fontSize: 8,
               fontStyle: 'normal',
            },
            evenRow: {
               fillColor: [239, 246, 255], // Very light blue
               textColor: 0,
               fontSize: 8,
               fontStyle: 'normal',
            },
            totalRow: {
               fillColor: [245, 238, 230], // Light tan
               textColor: 0,
               fontStyle: 'bold',
               fontSize: 8,
            },
            grandTotalRow: {
               fillColor: [241, 231, 231], // Light pink
               textColor: [255, 0, 0], // Red
               fontStyle: 'bold',
               fontSize: 8,
            },
         };

         let startY = 30; // Starting Y position after title and date

         // Get headers from columns
         const headers = columnsReportsSalesDetail.map((col) => col.header);

         salesReport.forEach((companyData, companyIndex) => {
            const companyTotals = calculateCompanyTotals(companyData);

            // Add company header with totals - as first row of the table
            const companyBody = [
               [
                  { content: `${companyData.companyName} (Total)`, styles: { fontStyle: 'bold' } },
                  '',
                  '',
                  '',
                  { content: companyTotals.receiptQtyTotal.toString(), styles: { halign: 'right' } },
                  { content: companyTotals.issueQtyTotal.toString(), styles: { halign: 'right' } },
                  { content: companyTotals.balanceTotal.toString(), styles: { halign: 'right' } },
                  { content: companyTotals.rateTotal.toString(), styles: { halign: 'right' } },
               ],
            ];

            // Add opening space before company
            if (companyIndex > 0) {
               startY += 5;
            }

            companyData.data.forEach((itemData, itemIndex) => {
               const itemTotals = calculateItemTotals(itemData);

               // Prepare item body data
               const itemBody = [
                  [
                     { content: `${itemData.itemName} (Total)`, styles: { fontStyle: 'bold' } },
                     '',
                     '',
                     '',
                     { content: itemTotals.receiptQtyTotal.toString(), styles: { halign: 'right' } },
                     { content: itemTotals.issueQtyTotal.toString(), styles: { halign: 'right' } },
                     { content: itemData.totalBal1.toString(), styles: { halign: 'right' } },
                     { content: itemTotals.rateTotal.toString(), styles: { halign: 'right' } },
                  ],
               ];

               // Prepare transaction data
               const transactionBody = [];

               // Add opening balance if exists
               if (itemData.totalOpeningBal1 > 0) {
                  transactionBody.push([
                     '',
                     '',
                     'Opening Balance',
                     '',
                     '',
                     '',
                     { content: itemData.totalOpeningBal1.toString(), styles: { halign: 'right', fontStyle: 'bold' } },
                     '',
                  ]);
               }

               // Add transaction data
               itemData.data.forEach((transaction) => {
                  transactionBody.push([
                     transaction.transactionAt ? formatDateToDDMMYYYY(transaction.transactionAt) : '',
                     transaction.docno || '',
                     transaction.accountName || '',
                     transaction.daybookName || '',
                     transaction.qty1 > 0 ? { content: transaction.qty1.toString(), styles: { halign: 'right' } } : '',
                     transaction.qty1 < 0
                        ? { content: Math.abs(transaction.qty1).toString(), styles: { halign: 'right' } }
                        : '',
                     transaction.bal1 !== undefined
                        ? { content: transaction.bal1.toString(), styles: { halign: 'right' } }
                        : '',
                     transaction.itemRate !== undefined
                        ? { content: transaction.itemRate.toString(), styles: { halign: 'right' } }
                        : '',
                  ]);
               });

               // Combine all data for this item
               const allBody = [...(itemIndex === 0 ? companyBody : []), ...itemBody, ...transactionBody];

               // Add the table
               doc.autoTable({
                  head: [headers],
                  body: allBody,
                  startY,
                  margin: { left: 10, right: 10 },
                  styles: {
                     fontSize: 8,
                     fontStyle: 'normal',
                  },
                  headStyles: {
                     fillColor: styles.tableHeader.fillColor,
                     textColor: styles.tableHeader.textColor,
                     fontStyle: styles.tableHeader.fontStyle,
                     fontSize: styles.tableHeader.fontSize,
                  },
                  bodyStyles: {
                     fontSize: 8,
                     fontStyle: 'normal',
                  },
                  alternateRowStyles: {
                     fillColor: styles.evenRow.fillColor,
                     fontStyle: 'normal',
                  },
                  columnStyles: {
                     0: { cellWidth: 'auto', halign: 'center' }, // Date
                     1: { cellWidth: 'auto', halign: 'center' }, // Doc#
                     2: { cellWidth: 'auto', halign: 'left' }, // Account
                     3: { cellWidth: 'auto', halign: 'left' }, // Daybook
                     4: { cellWidth: 'auto', halign: 'right' }, // Receipt Qty
                     5: { cellWidth: 'auto', halign: 'right' }, // Issue Qty
                     6: { cellWidth: 'auto', halign: 'right' }, // Balance
                     7: { cellWidth: 'auto', halign: 'right' }, // Rate
                  },
                  didParseCell: (data) => {
                     // Style for company and item total rows
                     if (
                        data.row.raw[0] &&
                        typeof data.row.raw[0] === 'object' &&
                        data.row.raw[0].content &&
                        data.row.raw[0].content.includes('(Total)')
                     ) {
                        data.cell.styles.fillColor = data.row.raw[0].content.includes(companyData.companyName)
                           ? styles.header.fillColor
                           : styles.subHeader.fillColor;
                        data.cell.styles.fontStyle = 'bold';
                     }

                     // Right align header columns for numerical data
                     if (data.section === 'head' && data.column.index >= 4 && data.column.index <= 7) {
                        data.cell.styles.halign = 'right';
                     }
                  },
                  didDrawPage: (data) => {
                     startY = data.cursor.y + 2; // Reduced space after table
                  },
               });
            });

            // Add a new page if we're not at the last company
            if (companyIndex < salesReport.length - 1) {
               doc.addPage('landscape');
               startY = 20;
            }
         });

         // Generate safe file name
         const now = new Date();
         const safeFileName = `Inventory_Detail_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.pdf`;

         // Save the PDF
         doc.save(safeFileName);
      } catch (error) {
         console.error('Error exporting to PDF:', error);
         alert('Failed to export PDF file. Please try again.');
      }
   };

   const renderDataRows = (itemData, companyData) => {
      if (!itemData || !Array.isArray(itemData)) return null;

      const handledata = async (data) => {
         const storedCompanyId = localStorage.getItem('companyId');
         const companyId = parseInt(storedCompanyId);
         if (data.companyId === companyId && data.daybookType === 20) {
            setEntityType('receivemaster');
            const response = await dispatch(getReceiveInventory(data.headerId));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (data.companyId === companyId && data.daybookType === 19) {
            setEntityType('issuemaster');
            const response = await dispatch(getIssueInventory(data.headerId));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (data.companyId === companyId && data.daybookType === 11) {
            setEntityType('purchaseinvoice');
            await dispatch(getPurchaseInvoice(data.headerId));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.companyId === companyId && data.daybookType === 5) {
            setEntityType('saleinvoice');
            await dispatch(getSaleInvoice(data.headerId));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.companyId === companyId && data.daybookType === 12) {
            setEntityType('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.id));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.headerId,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );

            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.companyId === companyId && data.daybookType === 6) {
            setEntityType('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.headerId,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
      };

      return (
         <>
            {/* Header row - shown once per expanded section */}
            <Tr
               bg={isDark ? 'gray.700' : 'blue.50'}
               borderTop="2px solid"
               borderColor={isDark ? 'blue.400' : 'blue.300'}>
               {columnsReportsSalesDetail.map((column) => (
                  <Th
                     key={column.id}
                     borderColor={isDark ? 'gray.600' : 'gray.300'}
                     p="10px"
                     py="12px"
                     fontSize="13px"
                     fontWeight="700"
                     color={isDark ? 'blue.200' : 'blue.800'}
                     whiteSpace="nowrap"
                     textTransform="uppercase"
                     letterSpacing="0.5px">
                     {column.header}
                  </Th>
               ))}
            </Tr>
            {companyData[0].totalOpeningBal1 > 0 && (
               <Tr
                  bg={isDark ? 'gray.750' : 'amber.50'}
                  borderLeft="3px solid"
                  borderColor={isDark ? 'amber.500' : 'amber.400'}>
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" py="10px" fontSize="11px"></Td>
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" py="10px" fontSize="11px"></Td>
                  <Td
                     borderColor={isDark ? 'gray.600' : 'gray.200'}
                     p="8px"
                     py="10px"
                     fontSize="14px"
                     fontWeight={700}
                     color={isDark ? 'amber.300' : 'amber.800'}
                     whiteSpace="nowrap">
                     Opening Balance
                  </Td>
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" py="10px" fontSize="11px"></Td>
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" py="10px" fontSize="11px"></Td>
                  <Td borderColor={isDark ? 'gray.600' : 'gray.200'} p="8px" py="10px" fontSize="11px"></Td>
                  <Td
                     borderColor={isDark ? 'gray.600' : 'gray.200'}
                     p="8px"
                     py="10px"
                     fontSize="14px"
                     fontWeight={700}
                     color={isDark ? 'amber.300' : 'amber.800'}
                     whiteSpace="nowrap">
                     {companyData[0].totalOpeningBal1}
                  </Td>
               </Tr>
            )}

            {/* Data rows */}
            {itemData.map((transaction, rowIndex) => {
               return (
                  <Tr
                     key={`row-${rowIndex}`}
                     className="editable-row"
                     bg={isDark ? 'gray.800' : 'white'}
                     _hover={{
                        bg: isDark ? 'gray.700' : 'blue.50',
                        transform: 'translateX(2px)',
                        transition: 'all 0.2s',
                        borderLeftColor: isDark ? 'blue.400' : 'blue.500',
                     }}
                     onClick={() => handledata(transaction)}
                     cursor="pointer"
                     borderLeft="2px solid transparent">
                     <Td
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        p="8px"
                        py="10px"
                        fontSize="13px"
                        fontWeight={500}
                        color={isDark ? 'gray.300' : 'gray.700'}
                        whiteSpace="nowrap">
                        {transaction.transactionAt ? formatDateToDDMMYYYY(transaction.transactionAt) : ''}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        p="8px"
                        py="10px"
                        fontSize="13px"
                        fontWeight={600}
                        color={isDark ? 'blue.300' : 'blue.700'}
                        whiteSpace="nowrap">
                        {transaction.docno || ''}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        p="8px"
                        py="10px"
                        fontSize="13px"
                        fontWeight={500}
                        color={isDark ? 'gray.200' : 'gray.800'}
                        whiteSpace="nowrap">
                        {transaction.accountName || ''}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        p="8px"
                        py="10px"
                        fontSize="13px"
                        fontWeight={500}
                        color={isDark ? 'gray.400' : 'gray.600'}
                        whiteSpace="nowrap">
                        {transaction.daybookName || ''}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        p="8px"
                        py="10px"
                        fontSize="13px"
                        fontWeight={600}
                        color={isDark ? 'green.300' : 'green.600'}
                        whiteSpace="nowrap">
                        {transaction.qty1 !== undefined && transaction.qty1 > 0 ? transaction.qty1 : '-'}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        p="8px"
                        py="10px"
                        fontSize="13px"
                        fontWeight={600}
                        color={isDark ? 'red.300' : 'red.600'}
                        whiteSpace="nowrap">
                        {transaction.qty1 !== undefined && transaction.qty1 < 0 ? transaction.qty1 : '-'}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        p="8px"
                        py="10px"
                        fontSize="13px"
                        fontWeight={600}
                        color={isDark ? 'purple.300' : 'purple.700'}
                        whiteSpace="nowrap">
                        {transaction.bal1 !== undefined ? transaction.bal1 : ''}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        p="8px"
                        py="10px"
                        fontSize="13px"
                        fontWeight={500}
                        color={isDark ? 'gray.300' : 'gray.700'}
                        whiteSpace="nowrap">
                        {transaction.itemRate !== undefined ? transaction.itemRate : ''}
                     </Td>
                  </Tr>
               );
            })}
         </>
      );
   };

   // Update the renderReportContent function to handle our data structure and fix the company name width issue
   const renderReportContent = () => {
      // Check if data exists and is in the expected format
      if (!salesReport || !Array.isArray(salesReport)) {
         return null;
      }
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={''} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }

      return salesReport.map((companyData, companyIndex) => {
         const companyTotals = calculateCompanyTotals(companyData);

         return (
            <React.Fragment key={`company-${companyData.companyId || companyIndex}`}>
               {/* Company Level */}
               <Tr
                  bg={
                     isDark
                        ? 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)'
                        : 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)'
                  }
                  _dark={{ bg: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)' }}
                  cursor="pointer"
                  width={'100%'}
                  onClick={() => toggleExpand(`company-${companyData.companyId}`)}
                  borderLeft="4px solid"
                  borderLeftColor={isDark ? 'blue.400' : 'blue.600'}
                  boxShadow={isDark ? '0 2px 8px rgba(59, 130, 246, 0.3)' : '0 2px 8px rgba(59, 130, 246, 0.15)'}
                  transition="all 0.3s"
                  _hover={{
                     bg: isDark
                        ? 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)'
                        : 'linear-gradient(135deg, #bfdbfe 0%, #93c5fd 100%)',
                     transform: 'translateX(4px)',
                     boxShadow: isDark ? '0 4px 12px rgba(59, 130, 246, 0.4)' : '0 4px 12px rgba(59, 130, 246, 0.25)',
                  }}>
                  <Td
                     p="10px"
                     py="14px"
                     fontSize="11px"
                     whiteSpace="nowrap"
                     color={isDark ? 'white' : 'blue.900'}
                     colSpan={columnsReportsSalesDetail.length}>
                     <Flex justifyContent="space-between" alignItems="center" width="100%">
                        <Text fontWeight="800" fontSize="15px" letterSpacing="0.5px">
                           {companyData.companyName}
                        </Text>
                        <Box
                           bg={isDark ? 'blue.500' : 'blue.600'}
                           borderRadius="full"
                           p="4px"
                           transition="transform 0.3s"
                           _groupHover={{ transform: 'rotate(180deg)' }}>
                           {expandedItems[`company-${companyData.companyId}`] ? (
                              <ChevronUpIcon boxSize="20px" color="white" />
                           ) : (
                              <ChevronDownIcon boxSize="20px" color="white" />
                           )}
                        </Box>
                     </Flex>
                  </Td>
               </Tr>

               {/* Show items if company is expanded */}
               {expandedItems[`company-${companyData.companyId}`] &&
                  companyData.data &&
                  Array.isArray(companyData.data) &&
                  companyData.data.map((itemData, itemIndex) => (
                     <React.Fragment key={`item-${itemData.itemId || itemIndex}`}>
                        {/* Item Level */}
                        <Tr
                           bg={isDark ? 'gray.750' : 'indigo.50'}
                           _dark={{ bg: 'gray.750' }}
                           cursor="pointer"
                           pl={2}
                           onClick={() => toggleExpand(`item-${itemData.itemId}`)}
                           borderLeft="3px solid"
                           borderLeftColor={isDark ? 'indigo.400' : 'indigo.500'}
                           transition="all 0.2s"
                           _hover={{
                              bg: isDark ? 'gray.700' : 'indigo.100',
                              transform: 'translateX(3px)',
                              borderLeftColor: isDark ? 'indigo.300' : 'indigo.600',
                           }}>
                           <Td
                              p="10px"
                              py="12px"
                              fontSize="14px"
                              whiteSpace="nowrap"
                              color={isDark ? 'indigo.200' : 'indigo.900'}
                              overflow="hidden"
                              colSpan={3}>
                              <Flex justifyContent="space-between" alignItems="center" pl={2} width="100%">
                                 <Text fontWeight="700" fontSize="15px">
                                    Item : {itemData.itemName}
                                 </Text>
                              </Flex>
                           </Td>
                           <Td
                              borderColor={isDark ? 'gray.600' : 'gray.300'}
                              p="10px"
                              py="12px"
                              fontSize="14px"
                              fontWeight={700}
                              color={isDark ? 'gray.300' : 'gray.700'}
                              whiteSpace="nowrap">
                              Item Total
                           </Td>
                           <Td
                              borderColor={isDark ? 'gray.600' : 'gray.300'}
                              p="10px"
                              py="12px"
                              fontSize="14px"
                              fontWeight={700}
                              color={isDark ? 'green.300' : 'green.700'}
                              whiteSpace="nowrap">
                              {(() => {
                                 const itemTotals = calculateItemTotals(itemData);
                                 return itemTotals.receiptQtyTotal;
                              })()}
                           </Td>
                           <Td
                              borderColor={isDark ? 'gray.600' : 'gray.300'}
                              p="10px"
                              py="12px"
                              fontSize="14px"
                              fontWeight={700}
                              color={isDark ? 'red.300' : 'red.700'}
                              whiteSpace="nowrap">
                              {(() => {
                                 const itemTotals = calculateItemTotals(itemData);
                                 return itemTotals.issueQtyTotal > 0 ? -itemTotals.issueQtyTotal : '-';
                              })()}
                           </Td>
                           <Td
                              borderColor={isDark ? 'gray.600' : 'gray.300'}
                              p="10px"
                              py="12px"
                              fontSize="14px"
                              fontWeight={700}
                              color={isDark ? 'purple.300' : 'purple.700'}
                              whiteSpace="nowrap">
                              {itemData?.totalBal1}
                           </Td>
                           <Td
                              borderColor={isDark ? 'gray.600' : 'gray.300'}
                              p="10px"
                              py="12px"
                              fontSize="14px"
                              fontWeight={700}
                              color={isDark ? 'gray.300' : 'gray.700'}
                              whiteSpace="nowrap">
                              <Flex alignItems="center" gap="8px">
                                 {(() => {
                                    const itemTotals = calculateItemTotals(itemData);
                                    return itemTotals.rateTotal || '-';
                                 })()}
                                 <Box bg={isDark ? 'indigo.500' : 'indigo.600'} borderRadius="full" p="2px">
                                    {expandedItems[`item-${itemData.itemId}`] ? (
                                       <ChevronUpIcon boxSize="16px" color="white" />
                                    ) : (
                                       <ChevronDownIcon boxSize="16px" color="white" />
                                    )}
                                 </Box>
                              </Flex>
                           </Td>
                        </Tr>
                        {/* Transaction Data */}
                        {expandedItems[`item-${itemData.itemId}`] &&
                           itemData.data &&
                           Array.isArray(itemData.data) &&
                           renderDataRows(itemData.data, companyData.data)}
                     </React.Fragment>
                  ))}

               {/* Company Summary - Optional */}
               {expandedItems[`company-${companyData.companyId}`] && (
                  <Tr
                     key={`row-${companyData.companyId}`}
                     className="editable-row"
                     bg={isDark ? 'gray.700' : 'yellow.50'}
                     borderTop="2px solid"
                     borderBottom="2px solid"
                     borderColor={isDark ? 'yellow.500' : 'yellow.400'}
                     boxShadow={isDark ? '0 2px 6px rgba(234, 179, 8, 0.2)' : '0 2px 6px rgba(234, 179, 8, 0.1)'}>
                     <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px" fontSize="13px"></Td>
                     <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px" fontSize="13px"></Td>
                     <Td borderColor={isDark ? 'gray.600' : 'gray.300'} p="10px" py="12px" fontSize="13px"></Td>
                     <Td
                        borderColor={isDark ? 'gray.600' : 'gray.300'}
                        p="10px"
                        py="12px"
                        fontSize="15px"
                        fontWeight={800}
                        color={isDark ? 'yellow.300' : 'yellow.800'}
                        whiteSpace="nowrap"
                        textTransform="uppercase"
                        letterSpacing="0.5px">
                        Grand Total
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.600' : 'gray.300'}
                        p="10px"
                        py="12px"
                        fontSize="15px"
                        fontWeight={700}
                        color={isDark ? 'green.300' : 'green.700'}
                        whiteSpace="nowrap">
                        {companyTotals.receiptQtyTotal}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.600' : 'gray.300'}
                        p="10px"
                        py="12px"
                        fontSize="15px"
                        fontWeight={700}
                        color={isDark ? 'red.300' : 'red.700'}
                        whiteSpace="nowrap">
                        -{companyTotals.issueQtyTotal}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.600' : 'gray.300'}
                        p="10px"
                        py="12px"
                        fontSize="15px"
                        fontWeight={700}
                        color={isDark ? 'purple.300' : 'purple.700'}
                        whiteSpace="nowrap">
                        {companyTotals.balanceTotal}
                     </Td>
                     <Td
                        borderColor={isDark ? 'gray.600' : 'gray.300'}
                        p="10px"
                        py="12px"
                        fontSize="15px"
                        fontWeight={700}
                        color={isDark ? 'gray.200' : 'gray.800'}
                        whiteSpace="nowrap">
                        {companyTotals.rateTotal}
                     </Td>
                  </Tr>
               )}
            </React.Fragment>
         );
      });
   };

   const memoizedReportContent = useMemo(() => {
      return renderReportContent();
   }, [salesReport, expandedItems]);

   const handleViewSingleData = async (id) => {
      await dispatch(getReceiveInventory(id));
      setIsOpenSingleViewinr(true);
   };

   const handleSalesSingleDataViewClose = () => {
      setIsOpenSingleViewinr();
   };

   const deletePurchaseReturn = () => {
      if (entityType === 'purchasereturn') {
         deleteRecord(viewDetail?.id, deletePurchaseReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'salereturn') {
         deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'saleinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deleteSaleInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'purchaseinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deletePurchaseInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   return (
      <>
         {/* Title Outside Card */}

         <Flex pr="25px" mb="8px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()} // Navigate to the previous page
                  style={{ cursor: 'pointer' }} // Ensure it's clickable
               ></img>
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Inventory Detail
               </Text>
            </Flex>
            <Flex gap={2}>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center">
               <Box flex="" gap={2} mr={3} display={{ base: 'none', xl: 'flex' }}>
                  <div flex="1" mr={''} justifyContent="center">
                     <Box
                        my={2}
                        width="300px"
                        fontSize={'13px'}
                        fontWeight={500}
                        mt={5}
                        display={{ base: 'none', xl: 'block' }}>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                     </Box>
                  </div>
               </Box>
               <Flex flex="" gap={2} mr={3}>
                  {/* <Box my={2} width="300px" fontSize={'13px'} display={{ base: 'none', xl: 'block' }} fontWeight={500}>
                     <label>Item</label>
                     <Select
                        placeholder="Select Item"
                        name="itemId"
                        options={itemOptions}
                        onChange={handleItemChange}
                        value={itemOptions.find((option) => option.value === itemId)} // Set the selected value
                        isMulti={true}
                        isClearable
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box> */}
               </Flex>
               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
               </Flex>
               <Flex flex="1"></Flex>
               <Box flex="" mr={3}>
                  <MotionFlex
                     ref={wrapperRef}
                     align="center"
                     bg={bg}
                     borderRadius="full"
                     cursor="pointer"
                     px={expanded ? 3 : 0}
                     w={expanded ? '250px' : '40px'}
                     h="40px"
                     transition="all 0.3s ease"
                     onClick={() => setExpanded(true)}>
                     <MotionSearchIcon
                        color={icon}
                        animate={{ rotate: expanded ? 0 : 90 }}
                        transition={{ duration: 0.3 }}
                        style={{
                           marginRight: expanded ? '8px' : '10px',
                           marginLeft: expanded ? '0' : '10px',
                        }}
                     />
                     {expanded && (
                        <InputGroup width="200px">
                           <Input
                              placeholder="Search accounts..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              variant="unstyled"
                              _focus={{ outline: 'none' }}
                           />
                           {isSearchLoading && <Spinner size="sm" color="blue.500" ml={2} />}
                        </InputGroup>
                     )}
                  </MotionFlex>
               </Box>
               <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                  <LuRefreshCcw size={20} mr={2} />
               </Button>
               <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                  <IoFilterOutline size={22} />
               </Button>
               <Popover>
                  <PopoverTrigger>
                     {/* Image as Clickable Button */}
                     <img src={Download} alt="Download" width="25" style={{ cursor: 'pointer' }} />
                  </PopoverTrigger>

                  <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                     <PopoverBody p="3">
                        <Button
                           width="100%"
                           variant="ghost"
                           _hover={{ bg: 'blue.100' }}
                           onClick={exportToExcel}
                           justifyContent="space-between"
                           mb={3}>
                           <img src={xls} alt="Download XLS" width="30px"></img>
                           Download Execl
                        </Button>
                        <Button
                           width="100%"
                           variant="ghost"
                           _hover={{ bg: 'blue.100' }}
                           onClick={exportToPDF}
                           justifyContent="space-between">
                           <img src={xls} alt="Download pdf" width="30px" mr></img>
                           Download Pdf
                        </Button>
                     </PopoverBody>
                  </PopoverContent>
               </Popover>
               {/* <Flex ml={''}>
                  <Box>
                     <DynamicFilterall
                        filters={[
                           {
                              name: 'Product',
                              options: Product,
                              defaultText: 'Select Product',
                              onSelect: (val) => setProductFilter(val),
                           },
                           {
                              name: 'Date',
                              options: secondOptions,
                              defaultText: 'Select Date',
                              type: 'date',
                              onSelect: (val) => setDateFilter(val),
                           },
                        ]}
                     />
                  </Box>
               </Flex> */}
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter, // Filter based on companyFilter values
                                 onChange: handleCompanyChange, // Handle change
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true, // isSearchable
                              undefined, // filteredOptions (optional, can be null or undefined)
                              true, // isMulti
                           )}
                        </GridItem>
                        <Box my={4} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Item</label>
                           <Select
                              placeholder="Select Item"
                              name="itemId"
                              options={itemOptions}
                              onChange={handleItemChange}
                              value={itemOptions.find((option) => option.value === itemId)} // Set the selected value
                              isMulti={true}
                              isClearable
                              className="basic-multi-select"
                              classNamePrefix="select"
                              styles={{
                                 control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '30px',
                                    height: '30px',
                                 }),
                                 valueContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                    padding: '0 6px',
                                 }),
                                 indicatorsContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                 }),
                              }}
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>

                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '70vh', md: '70vh', xl: '75vh' }}
                  maxH={{ base: '70vh', md: '70vh', xl: '75vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Tbody>
                        {salesReport?.length === 0 ? (
                           <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
                              <Td colSpan={columns.length} justifyContent="center" alignItems="center" width="100%">
                                 <Grid justifyContent="center" alignItems="center" gap={9}>
                                    <img
                                       src={nodata} // Replace with actual image URL
                                       alt="No Data Found"
                                       width="200px"
                                       height="200px"
                                    />
                                    <GridItem justifySelf="center">
                                       <label>No inventory data found</label>
                                    </GridItem>
                                 </Grid>
                              </Td>
                           </Tr>
                        ) : (
                           // Render data rows if available
                           memoizedReportContent
                        )}
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
            title={
               entityType === 'saleinvoice'
                  ? 'Sales Invoice'
                  : entityType === 'salereturn'
                     ? 'Sales Return'
                     : entityType === 'purchaseinvoice'
                        ? 'Purchase Invoice'
                        : 'Purchase Return'
            }
            entityType={entityType}
            singleEntity={viewDetail}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            // paginate={paginateData}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         />

         <SalesPurchaseFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyFilter}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            // type={stockTypeSelected?.value}
            entityType={'Inventory Detail'}
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityType}
            singleEntity={singleEntity}
            dynamicUserDetails={dynamicUserDetails}
            // initialIndex={initialIndex}
            // invoices={invoices}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityType === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />
      </>
   );
};

export default InventoryDetail;
